/* Parketvloerenhuis CRO productpagina: calculator, prijs per m2, verzendmoment, sticky koopbalk, benodigdheden */
(function () {
  var dataEl = document.getElementById('pvh-data');
  if (!dataEl) return;
  var D = JSON.parse(dataEl.textContent), V = D.v, lmin = D.lmin || 0, lmax = D.lmax || 0;
  var NL_DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var NL_MON = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function euro(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function nl(n) { return (Math.round(n * 10) / 10).toString().replace('.', ','); }

  /* ---------- Dekking ---------- */
  function segCov(seg) {
    if (lmin) {
      var l = seg.match(/(\d+(?:[.,]\d+)?)\s*(ml|l)\b/i);
      if (!l) return null;
      var liters = parseFloat(l[1].replace(',', '.')) / (l[2].toLowerCase() === 'ml' ? 1000 : 1);
      return { cov: liters * lmin, covMax: liters * lmax };
    }
    var m = seg.match(/(\d+(?:[.,]\d+)?)\s*m2/i);
    if (!m) return null;
    var c = parseFloat(m[1].replace(',', '.'));
    return c ? { cov: c, covMax: c } : null;
  }
  function variantCov(v) {
    var segs = v.t.split(' / ');
    for (var i = 0; i < segs.length; i++) {
      var c = segCov(segs[i]);
      if (c) { c.seg = segs[i]; c.label = segs[i].replace(/\s*\(.*?\)\s*/g, ' ').trim(); return c; }
    }
    return null;
  }
  function sizes() {
    var map = {};
    V.forEach(function (v) {
      var c = variantCov(v); if (!c) return;
      var s = map[c.label];
      if (!s) map[c.label] = { label: c.label, seg: c.seg, cov: c.cov, covMax: c.covMax, price: v.p };
      else if (v.p < s.price) s.price = v.p;
    });
    return Object.keys(map).map(function (k) { return map[k]; });
  }
  function best(sz, need) {
    need = Math.ceil(need);
    var maxCov = Math.max.apply(null, sz.map(function (s) { return Math.ceil(s.cov); }));
    var N = need + maxCov, b = [], from = [];
    b[0] = 0; for (var i = 1; i <= N; i++) b[i] = Infinity;
    for (var a = 0; a <= N; a++) {
      if (b[a] === Infinity) continue;
      sz.forEach(function (s, idx) {
        var t = Math.min(N, a + Math.floor(s.cov)), c = b[a] + s.price + 0.001;
        if (c < b[t]) { b[t] = c; from[t] = [a, idx]; }
      });
    }
    var end = -1, cost = Infinity;
    for (var x = need; x <= N; x++) if (b[x] < cost) { cost = b[x]; end = x; }
    if (end < 0) return null;
    var counts = sz.map(function () { return 0; });
    while (end > 0) { counts[from[end][1]]++; end = from[end][0]; }
    return counts;
  }
  var SZ = sizes();

  /* ---------- Geselecteerde variant ---------- */
  var form = $('.js-product-form');
  var idInput = form && $('[name="id"]', form);
  var mainBtn = form && $('.js-product-add', form);
  function current() {
    var id = idInput ? parseInt(idInput.value, 10) : 0;
    for (var i = 0; i < V.length; i++) if (V[i].id === id) return V[i];
    return V[0];
  }
  function qty() {
    var q = document.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  /* ---------- 1. Prijs per m2 ---------- */
  var m2El = $('.pvh-m2');
  function renderM2(v) {
    if (!m2El) return;
    var c = variantCov(v);
    if (!c) { m2El.hidden = true; return; }
    m2El.hidden = false;
    m2El.textContent = lmin
      ? euro(v.p / c.covMax) + ' tot ' + euro(v.p / c.cov) + ' per m² · genoeg voor ' + nl(c.cov) + ' tot ' + nl(c.covMax) + ' m²'
      : euro(v.p / c.cov) + ' per m² · genoeg voor ' + nl(c.cov) + ' m²';
  }

  /* ---------- 2. Label 'Voordeligst per m2' op het formaat ---------- */
  var cheapest = SZ.length > 1 ? SZ.slice().sort(function (a, b) { return a.price / a.cov - b.price / b.cov; })[0] : null;
  function badge() {
    if (!cheapest) return;
    $$('.product-form__swatch__item[data-value]').forEach(function (item) {
      if (item.querySelector('.pvh-best__badge')) return;
      var val = item.getAttribute('data-value');
      if (val === cheapest.seg || val.replace(/\s*\(.*?\)\s*/g, ' ').trim() === cheapest.label) {
        item.classList.add('pvh-best');
        var b = document.createElement('span');
        b.className = 'pvh-best__badge'; b.textContent = 'Voordeligst per m²';
        item.appendChild(b);
      }
    });
  }
  badge();

  /* ---------- 3. Calculator ---------- */
  var calc = $('.pvh-calc');
  if (calc && SZ.length) {
    calc.hidden = false;
    var input = $('.pvh-calc__input', calc), out = $('.pvh-calc__out', calc);
    input.addEventListener('input', function () {
      var m2 = parseFloat((input.value || '').replace(',', '.'));
      if (!m2 || m2 <= 0) { out.textContent = ''; return; }
      var counts = best(SZ, m2); if (!counts) { out.textContent = ''; return; }
      var parts = [], total = 0;
      SZ.forEach(function (s, i) { if (counts[i]) { parts.push(counts[i] + 'x ' + s.label); total += counts[i] * s.price; } });
      var txt = 'Advies: ' + parts.join(' + ') + ' (' + euro(total) + ').';
      if (lmin) txt += ' Reken op ' + nl(m2 / lmax) + ' tot ' + nl(m2 / lmin) + ' liter.';
      out.textContent = txt;
    });
  }

  /* ---------- 4. Verzendmoment ---------- */
  var shipEl = $('.pvh-ship');
  if (shipEl) {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
      var DAY = 864e5, today = Date.UTC(p.year, p.month - 1, p.day);
      var dow = function (t) { return new Date(t).getUTCDay(); };
      var nextWorkday = function (t) { do { t += DAY; } while (dow(t) === 0 || dow(t) === 6); return t; };
      var mins = (p.hour % 24) * 60 + p.minute, cutoff = D.cutoff * 60;
      var before = dow(today) >= 1 && dow(today) <= 5 && mins < cutoff;
      var ship = nextWorkday(before ? today : nextWorkday(today));
      var d = new Date(ship);
      var label = ship - today === DAY ? 'morgen (' + NL_DAYS[d.getUTCDay()] + ')' : 'op ' + NL_DAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + NL_MON[d.getUTCMonth()];
      var left = cutoff - mins, h = Math.floor(left / 60), mm = left % 60;
      var dur = (h ? h + ' u' : '') + (mm ? (h ? ' ' : '') + mm + ' min' : '');
      shipEl.innerHTML = before
        ? 'Bestel binnen <strong>' + dur + '</strong>, dan versturen we ' + label + '.'
        : 'Bestel nu, dan versturen we ' + label + '.';
      shipEl.hidden = false;
    } catch (e) { }
  }

  /* ---------- Winkelwagen + animatie ---------- */
  var CartP = null;
  try { CartP = import('cart-store').then(function (m) { return m.default; }).catch(function () { return null; }); } catch (e) { CartP = Promise.resolve(null); }
  function syncCount() {
    // Teller in header (desktop én mobiel) altijd zelf bijwerken, los van de thema-store
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$('items-count').forEach(function (el) { el.textContent = c.item_count; });
        $$('.cart-count-bubble').forEach(function (el) { el.classList.toggle('is-empty', !c.item_count); el.hidden = false; });
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c })); } catch (e) { }
        return c;
      }).catch(function () { });
  }
  function addToCart(id, quantity) {
    return CartP.then(function (Cart) {
      if (Cart && Cart.add) return Cart.add([{ id: id, quantity: quantity }]);
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: quantity }] }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); });
    }).then(function (res) { syncCount(); setTimeout(syncCount, 800); return res; });
  }
  function cartIcon() {
    var icons = $$('.secondary-nav__item--cart, .js-cart-icon');
    for (var i = 0; i < icons.length; i++) {
      var r = icons[i].getBoundingClientRect();
      if (r.width && r.bottom > 0 && r.top < window.innerHeight) return icons[i];
    }
    return null;
  }
  function fly(src, fromEl) {
    var target = cartIcon();
    var fr = fromEl.getBoundingClientRect();
    var tr = target ? target.getBoundingClientRect() : { left: window.innerWidth - 48, top: 12, width: 24, height: 24 };
    var size = 64;
    var img = document.createElement(src ? 'img' : 'div');
    if (src) img.src = src;
    img.className = 'pvh-fly';
    img.style.left = (fr.left + fr.width / 2 - size / 2) + 'px';
    img.style.top = (fr.top + fr.height / 2 - size / 2) + 'px';
    document.body.appendChild(img);
    var dx = tr.left + tr.width / 2 - (fr.left + fr.width / 2), dy = tr.top + tr.height / 2 - (fr.top + fr.height / 2);
    var anim = img.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 80) + 'px) scale(.7)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: .4 }
    ], { duration: 750, easing: 'cubic-bezier(.45,.05,.55,.95)' });
    anim.onfinish = function () {
      img.remove();
      var bump = target || document.body;
      if (target) { target.classList.remove('pvh-bump'); void target.offsetWidth; target.classList.add('pvh-bump'); }
    };
  }
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'pvh-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3500);
  }
  function addFlow(btn, id, quantity, imgSrc, name) {
    if (btn.disabled) return;
    var orig = btn.innerHTML;
    btn.disabled = true; btn.classList.add('is-busy'); btn.textContent = 'Toevoegen...';
    addToCart(id, quantity).then(function () {
      try { fly(imgSrc, btn); } catch (e) { }
      btn.classList.remove('is-busy'); btn.classList.add('is-done');
      btn.innerHTML = '✓ Toegevoegd';
      toast('<strong>' + (name || 'Product') + '</strong> zit in je winkelwagen. <a href="/cart">Bekijk winkelwagen</a>');
      setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; btn.classList.remove('is-done'); }, 2200);
    }).catch(function () {
      btn.classList.remove('is-busy'); btn.innerHTML = 'Opnieuw proberen'; btn.disabled = false;
    });
  }

  /* ---------- 5. Sticky koopbalk (desktop en mobiel) ---------- */
  var bar = $('.pvh-sticky');
  function renderBar(v) {
    if (!bar) return;
    $('.pvh-sticky__v', bar).textContent = (V.length > 1 ? v.t + ' · ' : '') + euro(v.p);
    var img = $('.pvh-sticky__img', bar);
    if (img && (v.img || D.img)) img.src = v.img || D.img;
    var b = $('.pvh-sticky__btn', bar);
    if (!b.classList.contains('is-busy') && !b.classList.contains('is-done')) {
      b.textContent = v.a ? 'In winkelwagen' : 'Uitverkocht';
      b.disabled = !v.a;
    }
  }
  if (bar && mainBtn) {
    document.body.appendChild(bar);
    document.body.classList.add('pvh-has-sticky');
    // tonen zodra de hoofdknop boven in beeld is weggescrold (ook bij snel scrollen of ankerlinks)
    var raf = 0;
    var check = function () {
      raf = 0;
      var on = mainBtn.getBoundingClientRect().bottom < 130;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('pvh-sticky-on', on);
    };
    var queue = function () { if (!raf) raf = requestAnimationFrame(check); };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    check();
    $('.pvh-sticky__btn', bar).addEventListener('click', function () {
      var v = current();
      if (!v.a) return;
      addFlow(this, v.id, qty(), v.img || D.img, D.title);
    });
  }

  /* ---------- 6. Benodigdheden toevoegen ---------- */
  $$('.pvh-xs__item').forEach(function (item) {
    var btn = $('.pvh-xs__add', item), sel = $('.pvh-xs__sel', item), price = $('.pvh-xs__price', item);
    if (sel) {
      // standaard de goedkoopste uitvoering kiezen
      var bi = 0, bp = Infinity;
      Array.prototype.forEach.call(sel.options, function (o, i) {
        var m = o.text.split('·').pop().replace(/[^\d,]/g, '').replace(',', '.');
        var pr = parseFloat(m);
        if (!isNaN(pr) && pr < bp) { bp = pr; bi = i; }
      });
      sel.selectedIndex = bi;
    }
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      if (price) price.textContent = o.getAttribute('data-price');
    });
    if (btn) btn.addEventListener('click', function () {
      var id = sel ? parseInt(sel.value, 10) : parseInt(btn.getAttribute('data-id'), 10);
      var img = $('img', item);
      addFlow(btn, id, 1, img ? img.src : '', btn.getAttribute('data-title'));
    });
  });

  /* ---------- Variantwissel volgen ---------- */
  var last = null;
  function tick() {
    badge();
    var v = current();
    if (v !== last) {
      last = v; renderM2(v); renderBar(v);
      if (shipEl && shipEl.innerHTML) shipEl.hidden = !v.a;
    }
  }
  tick();
  if (form) form.addEventListener('change', function () { setTimeout(tick, 50); });
  document.addEventListener('change', function () { setTimeout(tick, 80); });
  setInterval(tick, 600);
})();

/* Varianttegels: hoofdtekst + dekking op twee regels (21-10-2026) */
(function () {
  function split(root) {
    root.querySelectorAll('.product-form__swatch__item--button .product-form__swatch__label').forEach(function (l) {
      if (l.querySelector('.pvh-opt__main')) return;
      var m = l.textContent.trim().match(/^(.+?)\s*\((.+)\)$/);
      if (!m) return;
      var sub = m[2].replace(/(\d)\s*m2\b/i, '$1 m²');
      var a = document.createElement('span'), b = document.createElement('span');
      a.className = 'pvh-opt__main'; a.textContent = m[1].replace(/(\d)\s*l$/i, '$1 L');
      b.className = 'pvh-opt__sub'; b.textContent = (/m²/.test(sub) ? '≈ ' : '') + sub;
      l.textContent = ''; l.append(a, b);
    });
  }
  document.querySelectorAll('variant-radios').forEach(function (vr) {
    split(vr);
    new MutationObserver(function () { split(vr); }).observe(vr, { childList: true, subtree: true });
  });
})();
